import { render } from "./PilihanJawaban.vue?vue&type=template&id=c820fd42"
import script from "./PilihanJawaban.vue?vue&type=script&lang=js"
export * from "./PilihanJawaban.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__